import s from './ChatInfo.module.css';
import '../styles.css';
import {ArrowLeftIcon, CloseIcon, EditIcon, PlusIcon} from "@/utils/icons";
import React, {useEffect, useState, useMemo, useRef} from "react";
import {chatApi} from "@/api";
import MemberElem from "@common/Chat/components/MemberElem";
import classNames from "classnames";
import {useSelector} from "react-redux";
import {selectProfile} from "@store/profile.reducer";
import {Input} from "antd";
import Popup from "@common/Chat/components/Popup/Popup";
import UserImage from "@common/Chat/components/UserImage/UserImage";
import {useAddAlert} from "@/hooks/useAddAlert";
import useIsTechSupport from '../SupportChatButton/useIsTechSupport';
import { declOfNum } from '@/helpers/declOfNum';
import debounce from "lodash.debounce";
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet';
import { roleAdminInChat, rolesChatParticipants } from '../constants';

const ChatInfo = ({chat, setPage, params, isFullPage = false}) => {
    const profile = useSelector(selectProfile);
    const [data, setData] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [titleChat, setTitleChat] = useState(null);
    const [action, setAction] = useState(false)
    const meInChat = data?.members.find(el => el.user_id === profile.id);
    const filteredMembers = isAdmin ? data?.members.filter((member) => rolesChatParticipants[member.role] === roleAdminInChat) : data?.members;
    const [isNeedUpdate, setIsNeedUpdated] = useState(false);
    const [isVisiblePopup, setIsVisiblePopup] = useState(false);
    const [header, setHeader] = useState('')
    const [delId, setDelId] = useState(null);
    const [type, setType] = useState('')
    const [isUpdateImage, setIsUpdateImage] = useState(false)
    const [image, setImage] = useState(null)
    const addAlert = useAddAlert()
    const [uploading, setUploading] = useState(false)
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        chatApi.getChat(chat).then((res) => {
            setData(res?.data)
            setTitleChat(res?.data?.name)
            setIsNeedUpdated(false)
        })
    }, [chat, isNeedUpdate]);

    const [chatHideHistory, setChatHideHistory] = useState(false)
    const [updating, setUpdating] = useState(false);
    const updateChatHideHistory = () => {
        if(!data?.id) {
            addAlert({title: 'Ошибка', text: 'чат не выбран', type: 'error'})
            return;
        }
        if(updating) return;
        setUpdating(true)
        const newChatHideHistory = !chatHideHistory;
        chatApi.updateChatHideHistory({
            chatId: data.id,
            is_hide_history: newChatHideHistory 
        })
        .then(({data})=>{
            if(data.status === 'success'){
                addAlert({title: 'Успешно', text: 'Настройка сохранена'})
                setChatHideHistory(newChatHideHistory)
            }
        })
        .finally(() => setUpdating(false))
    }

    useEffect(()=>{
        setChatHideHistory(!!data?.is_hide_history)
    }, [data?.is_hide_history])
    useEffect(() => {
        if (action) {
            if (type ==='removeMember') {
                deleteMember()
            } else if (type === 'changeImage') {
                saveLogo()
            }

        }
    }, [action])
    const deleteMember = () => {
        chatApi.deleteMember(delId)
            .then((res) => {
                if (res?.status === 200) {
                    setIsNeedUpdated(true)
                    setIsVisiblePopup(false)
                    setType('')
                    setAction(false)
                } else {
                    addAlert({text: 'Обратитесь к администратору чата'})
                    setIsNeedUpdated(true)
                    setIsVisiblePopup(false)
                    setType('')
                    setAction(false)
                }
            })
    }

    const debouncedUpdateChatTitle = useMemo(() => {
            return (
                debounce((chatId, title) => {
                    if (!chatId || !title?.trim()) return;
                    
                    chatApi.updateChatTitle(chatId, {
                        chatName: title.trim()
                    })
                    .then(({data}) => {
                        if(data?.success){
                            addAlert({title: 'Успешно', text: 'Новое название чата сохранено'});
                        }
                    });
                }, 1000)
            )
        }, []
    );
    
    const isFirstRender = useRef(true);
    useEffect(() => {
        if(!data?.id || !titleChat) return;

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        debouncedUpdateChatTitle.cancel();

        debouncedUpdateChatTitle(data.id, titleChat);
        
        return () => {
            debouncedUpdateChatTitle.cancel();
        };
    }, [titleChat, data?.id]);

    const addNewParticipants = () => {
        setPage('create', data, 'add')
    }

    const exit = () => {
        setType('removeMember')
        setDelId(meInChat.member_id)
        setHeader('Вы действительно хотите покинуть чат?')
        setIsVisiblePopup(true)
    }

    const saveLogo = () => {
        if (image === null) {
            addAlert({title: 'Не выбран файл логотипа'});
            return;
        }

        const data = new FormData();
        if (typeof image === 'object') {
            data.append('file', image);
        }
        setUploading(true)
        chatApi.updateChatImage(chat, data, {
            onUploadProgress: function (progressEvent) {

                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgress(percentCompleted)
            }
        }).then((res) => {
            if (res?.status === 200) {
                setIsUpdateImage(false)
                setImage(null)
                setIsNeedUpdated(true)
                setIsVisiblePopup(false)
                setType('')
                addAlert({text: 'Изображение успешно загружено'})
                setAction(false)
                setUploading(false)
                setProgress(0)
            } else {
                addAlert({text: 'Изображение не загружено, обратитесь к администратору'})
            }
        })
    }

    const handleEditImage = () => {
        setHeader('Замена изображения чата')
        setIsVisiblePopup(true)
        setIsUpdateImage(true)
        setType('changeImage')
    }
    const { isTechSupport, chatIsDisabledButTechnicalSupportIsEnabled } = useIsTechSupport()
    const isChatAdmin = rolesChatParticipants[meInChat?.role] === roleAdminInChat;
    const handleClose = () => {
        if (!isFullPage) {
            setPage('default')
            return
        }

        if(isTechSupport || !chatIsDisabledButTechnicalSupportIsEnabled){
            setPage('main', null, 'create', params)
        }
        else{
            setPage('inChat', chat, 'create', params)
        }
    }
    
    return (
        <div className={classNames(s.page, 'chat-info')}>
            <div className={s.header}>
                <div className={s.headerTitle}>
                    <button
                        type={'button'}
                        className={s.btn}
                        onClick={() => setPage('inChat', chat, 'create', params)}
                    >
                        <ArrowLeftIcon/>
                    </button>
                    <div className={s.title}>
                        Информация
                    </div>
                </div>
                
                <div
                    className={s.close}
                    title={isFullPage ? 'Закрыть' : 'Свернуть чат'}
                    aria-label={isFullPage ? 'Закрыть' : 'Свернуть чат'}
                    role="button"
                    tabIndex={0}
                    onClick={handleClose}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') handleClose()
                    }}
                >
                    <CloseIcon width={'24'} height={'24'}/>
                </div>
            </div>
            <div className={classNames(s.info, s.profileCard)}>
                <UserImage path={data?.avatar} customClass={s.big}/>
                <div className={s.edit} onClick={handleEditImage} hidden={!isChatAdmin}>
                    <EditIcon/>
                </div>
                <div className={s.profileContent}>
                    <div className={s.title}>
                        <Input
                            disabled={!isChatAdmin}
                            className={classNames(s.input, {[s.inputForEditing]: isChatAdmin})}
                            value={titleChat}
                            placeholder={'Введите название чата'}
                            onChange={e => setTitleChat(e.target.value)}
                        />
                    </div>
                    <div className={s.numbers}>{data?.members?.length} {declOfNum(data?.members?.length, ['участник', 'участника', 'участников'])} </div> 
                </div>
            
            </div>
            {
                meInChat && isChatAdmin && (
                    <div className={s.settingsCard}>
                        <CheckboxViolet onClick={updateChatHideHistory} text='Скрыть историю чата от новых пользователей' value={chatHideHistory} />
                    </div>
                )
            }
            
            <div className={s.tabs}>
                <div className={classNames(s.tab, !isAdmin ? s.active : '')} onClick={() => setIsAdmin(false)}>Все
                    участники
                </div>
                <div className={classNames(s.tab, isAdmin ? s.active : '')} onClick={() => setIsAdmin(true)}>Администраторы</div>
            </div>
            {meInChat && isChatAdmin && <div className={s.addBlock}>
                <div className={s.addElem} onClick={addNewParticipants}>
                    <div className={s.plus}><PlusIcon/></div>
                    <div className={s.label}> Добавить участников</div>
                </div>
            </div>}
            <div className={classNames('new-design-scroll', s.membersList)}>
                {filteredMembers && filteredMembers.map((member) => (
                    <MemberElem
                        user={member}
                        key={member.member_id}
                        setPage={setPage}
                        isGroupChat={data?.type === 'group'}
                        myRoleInChat={meInChat?.role}
                        setAction={setAction}
                        action={action}
                        setIsNeedUpdated={setIsNeedUpdated}
                        setHeader={setHeader}
                        setIsVisiblePopup={setIsVisiblePopup}
                        setDelId={setDelId}
                        setType={setType}
                    />
                ))}
            </div>
            {meInChat && <div className={s.exit} onClick={exit}>
                Покинуть чат
            </div>}
            {/* {isVisiblePopup && <Popup
                isVisiblePopup={isVisiblePopup}
                closeCallback={() =>  setIsVisiblePopup(false)}
                header={header}
                updateImage={isUpdateImage}
                setAction={setAction}
                setImage={setImage}
                image={image}
                progress={progress}
                uploading={uploading}
            />} */}
            {isVisiblePopup && <Popup 
                isVisiblePopup={isVisiblePopup} 
                closeCallback={() =>  setIsVisiblePopup(false)} 
                header={header} 
                updateFile={isUpdateImage} 
                setAction={setAction} 
                setFile={setImage} 
                file={image} 
                progress={progress}
                uploading={uploading}
            />}
        </div>
    )
}

export default ChatInfo;
